import React from "react";
import styled from "styled-components";
import COLORS from "common/Colors";
import { Modal, Spin } from "antd";
import Table from "atoms/Table";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);

const StyledModal = styled(Modal)`
  .ant-modal-header {
    border-bottom: none;
    padding-top: 20px;
  }
  .ant-modal-title {
    font-weight: bold;
    font-weight: 1.2rem;
  }
  .ant-form-item-label {
    font-weight: 500;
  }
  .ant-modal-footer {
    border-top: none;
    padding-bottom: 20px;
  }
  .ant-modal-content {
    min-width: 800px;
    min-height: 220px;
  }
`;

const StyledTable = styled(Table)`
  padding-top: 10px;
  table {
    width: 100% !important;
    border: 1px solid #ccc;
  }
  .ant-table-content {
    overflow-x: auto;
    white-space: nowrap;
    color: ${COLORS.TEXT.PRIMARY};
    font-size: 14px;
  }
  .ant-table-row:nth-child(even) {
    background-color: #fafafa;
  }
  .normal-column {
    min-width: 300px;
    white-space: normal;
  }
  .ant-table-thead .ant-table-cell {
    font-weight: bold;
    color: ${COLORS.TEXT.PRIMARY};
    white-space: nowrap;
  }
  .non-white {
    background: #f9f9f9;
  }
  .ant-select-selector {
    min-width: 150px;
  }
`;

const columns = [
  {
    title: "File Name",
    dataIndex: "filename",
  },
  {
    title: "File ID",
    dataIndex: "fileid",
  },
  {
    title: "From Date",
    dataIndex: "fromdate",
  },
  {
    title: "To Date",
    dataIndex: "todate",
  },
  {
    title: "Updated by",
    dataIndex: "updatedby",
  },
];

const HistoryModal = ({
  isHistoryModalOpen,
  setIsHistoryModalOpen,
  historyData,
  isHistoryModalLoader,
}) => {
  const formattedData = historyData
    ?.slice() // clone array to avoid mutating props
    .sort((a, b) => new Date(b.updatedat) - new Date(a.updatedat)) // sort descending
    .map((item, index) => {
      const nameLine = item.employeeid
        ? `${item.employeename} (${item.employeeid})`
        : item.updatedby;

      const dateLine = item.updatedat
        ? dayjs(item.updatedat).format("DD MMM YYYY ; hh:mm A")
        : "---";

      return {
        key: index,
        filename: item.filename,
        fileid: item.fileid,
        fromdate: item.fromdate
          ? dayjs(item.fromdate, "DD-MM-YYYY").isValid()
            ? dayjs(item.fromdate, "DD-MM-YYYY").format("DD MMM YYYY")
            : "---"
          : "---",
        todate: item.todate
          ? dayjs(item.todate, "DD-MM-YYYY").isValid()
            ? dayjs(item.todate, "DD-MM-YYYY").format("DD MMM YYYY")
            : "---"
          : "---",
        updatedby: (
          <div>
            <div>{nameLine}</div>
            <div style={{ fontStyle: "italic", color: "#555" }}>{dateLine}</div>
          </div>
        ),
      };
    });

  const handleClose = () => {
    setIsHistoryModalOpen(false);
  };

  return (
    <StyledModal
      title="History"
      open={isHistoryModalOpen}
      onCancel={handleClose}
      footer={[]}
      style={{ maxWidth: 1500 }}
    >
      <Spin spinning={isHistoryModalLoader} tip="Loading...">
        <StyledTable
          columns={columns}
          dataSource={formattedData}
          pagination={false}
        />
      </Spin>
    </StyledModal>
  );
};

export default HistoryModal;
